const { I18n } = window || global

export { I18n }
export default I18n
